// extracted by mini-css-extract-plugin
export var wrapper = "PostPreview-module--wrapper--kOhRh";
export var thumbnail = "PostPreview-module--thumbnail--3MJnR";
export var title = "PostPreview-module--title--Wv2Pk";
export var copy = "PostPreview-module--copy--Egs8Y";